import "./certificateInput.scss";
import SwitchUI from "../../../components/UI/SwitchUi/SwitchUi";
import { ReactComponent as ArrowLeftIcon } from "../../../assets/icons/arrow-leff-circle.svg";
import { findSertificate } from "../../../http/orderApi";
import { priceToUserString } from "../../../http/basketApi";
import { observer } from "mobx-react-lite";

const CertificateInput = observer(({ handleChange, basket, index }) => {
  const handleToggleChange = (e) => {
    const checked = e.target.checked;

    if (!checked) {
      basket.setCertificate(index, {
        value: "",
        isActive: false,
        toggle: false,
        message: "",
        loading: false,
        amount: 0,
      });
    } else {
      basket.setCertificate(index, { toggle: true });
    }
  };

  const handleCertInputChange = (value) => {
    basket.setCertificate(index, { value, message: "", isActive: false });
  };

  const checkSertificateSuccessHandler = (sertificateCode, orderInfo) => {
    if (!sertificateCode) {
      basket.setCertificate(index, { message: "Введите номер сертификата" });
      return;
    }
    basket._useCertificate = true

    basket.setCertificate(index, {
      loading: true,
    });

    findSertificate(sertificateCode, orderInfo)
      .then((response) => {
        if (response.error) {
          basket.setCertificate(index, {
            message: response.error,
            isActive: false,
            amount: 0,
          });

          return;
        }

        if (response.message && response.amount) {
          basket.setCertificate(index, {
            value: sertificateCode,
            isActive: true,
            message: response.message,
            amount: response.amount,
          });
          handleChange?.(response.amount);

          basket.addCertificate();
        }
      })
      .finally(() => {
          basket._useCertificate = false
          basket.setCertificate(index, {
            loading: false,
          })
        }


      );
  };

  const handleDelete = () => {
    basket.removeCertificate(index);
  };

  return (
    <div className="certificate">
      <span className="certificate__title">
        Сертификат
        <SwitchUI
          checked={basket.certificates[index].toggle}
          onChange={handleToggleChange}
        />
      </span>

      {basket.certificates[index].toggle && (
        <div className="certificate__input">
          {!basket.certificates[index].isActive ? (
            <span>Номер сертификата*</span>
          ) : null}
          {basket.certificates[index].loading ? (
            <div className="certificate__skeleton" />
          ) : (
            <>
              {!basket.certificates[index].isActive ? (
                <div className="certificate__input-wrapper">
                  <input
                    value={basket.certificates[index].value}
                    onChange={(e) => handleCertInputChange(e.target.value)}
                    disabled={basket.certificates[index].isActive}
                  />
                  <div
                    onClick={() =>
                      checkSertificateSuccessHandler(
                        basket.certificates[index].value
                      )
                    }
                    className="certificate__icon"
                  >
                    <ArrowLeftIcon />
                  </div>
                </div>
              ) : (
                <div className="certificate__amount">
                  <p className="certificate__amount-value">{`Сертификат на ${priceToUserString(
                    basket.certificates[index].amount
                  )} ₽`}</p>
                  <p
                    onClick={handleDelete}
                    className="certificate__amount-delete"
                  >
                    Удалить
                  </p>
                </div>
              )}
            </>
          )}

          {basket.certificates[index].message &&
          !basket.certificates[index].isActive ? (
            <div className="certificate__message">
              {basket.certificates[index].message}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
});

export default CertificateInput;
